import { AppRoutes } from "@/shared/lib/routes"
import { ShieldCheck } from "lucide-react"

import { LegalLink } from "@/shared/components/legal-link"

/** Legal / data-safety block shown under the email step's footer button. */
export function QuizLegalNote() {
  return (
    <div className="flex flex-col gap-2 rounded-2xl bg-purple-light/10 p-4">
      <div className="flex items-center gap-3">
        <ShieldCheck className="size-5 shrink-0 text-green-500" />
        <p className="flex-1 text-xs text-purple-light/70">
          Your personal data is safe with us. We'll use your email for updates, receipts, and
          subscription details.
        </p>
      </div>
      <p className="pl-8 text-xs text-purple-light/70">
        We respect your privacy. By continuing, you agree to our{" "}
        <LegalLink to={AppRoutes.TERMS} className="text-purple-light underline">
          Terms &amp; Conditions
        </LegalLink>{" "}
        and{" "}
        <LegalLink to={AppRoutes.PRIVACY} className="text-purple-light underline">
          Privacy Policy
        </LegalLink>
        .
      </p>
    </div>
  )
}
